/**
 * @format
 * @flow
 */
import * as Setting from '../constants/reducers/Setting';

const initialState = {
  currentSetting: {
    enterpriseId: '',
    enterpriseName: '',
    enterpriseCategory: '',
    enterprisePhotoId: '',
    postalCode: '',
    prefecture: '',
    municipality: '',
    street: '',
    email: '',
    phone: '',
    lineCd: '',
    stationCd: '',
    way: '',
    workTime: '',
    description: '',
    faq: '',
    delta: ''
  },
  categories: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Setting.GET_SETTING:
      // console.log('GET_SETTING', action.data)
      return {
        ...state,
        currentSetting: action.data.enterprise,
        categories: action.data.categoryOptions,
        currentSettingLoaded: true
      };
    case Setting.UPDATE_SETTING:
      console.log('UPDATE_SETTING+++++++++++++++++++++++++', action.data);
      return {
        ...state,
        currentSetting: action.data.enterprise,
        currentSettingUpdated: true
      };
    case Setting.GET_ENTERPRISE_CATEGORIES:
      // console.log("GET_ENTERPRISE_CATEGORIES", action.data);
      return { ...state, categories: action.data.categoryOptions };
    default:
      return state;
  }
}
